var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgPlus = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M12.75,11.25 L19,11.25 C19.4142136,11.25 19.75,11.5857864 19.75,12 C19.75,12.4142136 19.4142136,12.75 19,12.75 L12.75,12.75 L12.75,19 C12.75,19.4142136 12.4142136,19.75 12,19.75 C11.5857864,19.75 11.25,19.4142136 11.25,19 L11.25,12.75 L5,12.75 C4.58578644,12.75 4.25,12.4142136 4.25,12 C4.25,11.5857864 4.58578644,11.25 5,11.25 L11.25,11.25 L11.25,5 C11.25,4.58578644 11.5857864,4.25 12,4.25 C12.4142136,4.25 12.75,4.58578644 12.75,5 L12.75,11.25 Z"
  }));
};
export default SvgPlus;